import React, { Component } from 'react'
import { MmModal } from './../../shared_components/modal/Modal.view'
import { t } from './../../jsCore/providers/i18nProvider/i18nProvider'

export class MessageBox extends Component {
  constructor(props) {
    super(props)
    this.state = { message: null }
  }

  handleChange = ({ target: { value } }) => this.updateMsg(value)

  updateMsg = msg => this.setState({ message: msg })

  handleSubmit = e => {
    e.preventDefault()

    this.props.handleMessage(this.state.message)
    this.props.close()

    this.updateMsg(null)
  }

  render() {
    const { isOpen, close } = this.props
    const BLOCK_NAME = 'message-box'

    return (
      <MmModal isOpen={isOpen} close={close} contentLabel="sendMessage">
        <form onSubmit={this.handleSubmit} className={BLOCK_NAME}>
          <h1 className={`${BLOCK_NAME}__header`}>{t('private_messages.private_message')}</h1>
          <textarea
            className={`${BLOCK_NAME}__message`}
            onChange={this.handleChange}
            rows={3}
            placeholder={t('private_messages.write_message_here')}
          />
          <input className={`${BLOCK_NAME}__submit`} type="submit" value={t('settings.submit')} />
        </form>
      </MmModal>
    )
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/message_user/MessageBox.container.js